module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"total_weight":"Total weight","weight_on_body":"Weight on body","weight_packed":"Weight packed"},"de":{"total_weight":"Gesamtgewicht","weight_on_body":"Gewicht am Körper","weight_packed":"Gepacktes Gewicht"}}')
  delete Component.options._Ctor
}
